import { round, sumBy } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { CapitalActionFormValues } from '../../../hooks/useCapitalActionForm';

export default function useSyncInitialDistributionValues({
  fundsRemainingToDistribute,
  entryIndex,
}: {
  fundsRemainingToDistribute: Array<{
    commitmentId: string;
    investorLabel: string;
    availableToDistributeSubjectToCarry: number;
    availableToDistributeOutsideOfCarry: number;
  }>;
  entryIndex: number;
}) {
  const { setValue, getValues } = useFormContext<CapitalActionFormValues>();

  const setTotalAmountAndCapitalBreakdown = (
    fundsRemainingToDistribute: Array<{
      commitmentId: string;
      investorLabel: string;
      availableToDistributeSubjectToCarry: number;
      availableToDistributeOutsideOfCarry: number;
    }>,
  ) => {
    setValue(
      `entries.${entryIndex}.totalAmount`,
      round(
        sumBy(fundsRemainingToDistribute, (funds) =>
          round(
            funds.availableToDistributeSubjectToCarry +
              funds.availableToDistributeOutsideOfCarry,
            2,
          ),
        ),
        3,
      ),
    );

    const capitalBreakdown = fundsRemainingToDistribute.map(
      (fundsRemainingToDistribute) => ({
        commitmentId: fundsRemainingToDistribute.commitmentId,
        amountLcy:
          fundsRemainingToDistribute.availableToDistributeSubjectToCarry,
        fundsDistributed: {
          subjectToCarry:
            fundsRemainingToDistribute.availableToDistributeSubjectToCarry,
          outsideOfCarry:
            fundsRemainingToDistribute.availableToDistributeOutsideOfCarry,
          recallableOutsideOfCarry:
            fundsRemainingToDistribute.availableToDistributeOutsideOfCarry,
          recallableSubjectToCarry:
            fundsRemainingToDistribute.availableToDistributeSubjectToCarry,
        },
      }),
    );

    setValue(`entries.${entryIndex}.capitalBreakdown`, capitalBreakdown);
  };

  useEffect(() => {
    if (getValues(`entries.${entryIndex}.capitalBreakdown`)?.length) {
      return;
    }

    setTotalAmountAndCapitalBreakdown(fundsRemainingToDistribute);
  }, [fundsRemainingToDistribute, entryIndex]);

  return { setTotalAmountAndCapitalBreakdown };
}
